module.exports = __webpack_public_path__ + "static/media/gallery-img-3.bf6e0e81.jpg";